const state = () => ({
    context: false,
    currentComponentByBlock: {}
})

/**
 * Devuelve la instancia efectiva de un bloque:
 * 1) si hay una sola instancia válida, usa esa
 * 2) si hay selección actual para el bloque, usa esa
 * 3) fallback a la instancia publicada
 */
function getCurrentInstance(block, currentComponentByBlock = {}) {
    block = block || {}
    let components = Object.values(block.components || [])

    if (components.length === 0) return null;
    if (components.length === 1 && components[0].status !== -1) return components[0];

    const blockId = Number(block.id);
    const currentComponentId = blockId ? Number(currentComponentByBlock[blockId]) : NaN;

    if (blockId && currentComponentId) {
        const selected = components.find(component => Number((component || {}).id) === currentComponentId);
        if (selected) return selected;
    }

    const published = components.find(component => component && component.status == 1);
    return published || null;
}

/**
 * Recorre bloques y devuelve ocurrencias de NEWS repetidas entre instancias efectivas
 */
function computeDuplicatedContents(blocks, currentComponentByBlock) {
    const occurrences = [];
    const counts = {};

    blocks = Object.values(blocks || [])

    for (const block of blocks) {
        const instance = getCurrentInstance(block, currentComponentByBlock);
        if (!instance) continue;

        const component = instance.component || {}
        const contentType = String(component.contentType || '').toUpperCase();
        if ('NEWS' !== contentType) continue;

        const content = instance.content || {}
        let newsItems = Object.values(content.news || [])

        if (newsItems.length === 0) continue;

        for (let index = 0; index < newsItems.length; index++) {
            const newsId = newsItems[index].id;
            if (!newsId) continue;

            const occurrence = {
                instance: instance.id,
                news: Number(newsId),
                order: index + 1
            }
            occurrences.push(occurrence)
            counts[occurrence.news] = (counts[occurrence.news] || 0) + 1
        }
    }

    return occurrences.filter(occurrence => (counts[occurrence.news] || 0) > 1)
}

// getters
const getters = {
    context (state) {
        return state.context
    },
    isEnabled(state)
    {
        return state.context
    },
    /**
     * Getter derivado: calcula notas duplicados usando `section/blocks` + selección actual por bloque.
     */
    duplicatedContents (state, getters, rootState, rootGetters)
    {
        const blocks = rootGetters['section/blocks'] || [];
        return computeDuplicatedContents(blocks, state.currentComponentByBlock);
    }
}

// mutations
const mutations = {
    setContext (state, payload) {
        state.context = payload
    },
    /**
     * Guarda o limpia el componente actualmente editado para un bloque.
     */
    setCurrentComponent (state, payload) {
        const blockId = Number(payload.blockId);
        const componentId = Number(payload.componentId);
        if (!blockId) return;

        if (!componentId) {
            const next = { ...state.currentComponentByBlock };
            delete next[blockId];
            state.currentComponentByBlock = next;
        } else {
            state.currentComponentByBlock = {
                ...state.currentComponentByBlock,
                [blockId]: componentId
            };
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations
}
